module.exports = __webpack_public_path__ + "img/conference6.8381eafe.png";